import { render } from "./MySeatBookings.vue?vue&type=template&id=86395524"
import script from "./MySeatBookings.vue?vue&type=script&lang=js"
export * from "./MySeatBookings.vue?vue&type=script&lang=js"

import "./MySeatBookings.vue?vue&type=style&index=0&id=86395524&lang=less"
script.render = render

export default script